import React from 'react';
export interface IIconChevronProps {
	className?: string;
	size?: string;
	customSize?: number;
	customColor?: string;
}

const IconChevron = ({ className, size, customSize, customColor }: IIconChevronProps) => {
    if (size === 'large') {
        return (
            <svg
                className={`IconChevron icon ${className || ''}`}
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                color= {customColor || undefined}
            >
                <path
                    d='M7.50024 3L16.5002 12L7.50024 21'
                    stroke='currentColor'
                    strokeWidth='3'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        );
    } else if (size === 'medium') {
        return (
            <svg
                className={`IconChevron icon ${className || ''}`}
                width='20'
                height='21'
                viewBox='0 0 20 21'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                color= {customColor || undefined}
            >
                <path
                    d='M6.25 3L13.75 10.5L6.25 18'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        );
    } else if (customSize) {
        return (
            <svg
                className={`IconChevron icon ${className || ''}`}
                width={customSize}
                height={customSize}
                viewBox='4.75 1.75 17.5 17.5'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                color= {customColor || undefined}
            >
                <path
                    d='M6.25 3L13.75 10.5L6.25 18'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        );
    } else {
        return (
            <svg
                className={`IconChevron icon ${className || ''}`}
                width={'16'}
                height='17'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                color= {customColor || undefined}
            >
                <path
                    d='M5 2.5L11 8.5L5 14.5'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        );
    }
};

export default IconChevron;
